import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { AuthService } from "services/AuthService";

import MainButton from "../../atoms/RoundedButton";
import Tooltip from "../../atoms/Tooltip";
import Icon from "components/MainApp/atoms/Icon/icon";

import styles from "./MainApp.layouts.HeadTipShelf.module.scss";
import imageFileYax from "assets/images/icon-yax-text.png";
import imageFileIderoTech from "assets/images/iderotech.png";
import imageFileYaxMobile from "assets/images/icon-yax-text-Mobile.png";
import imageFileYaxMobileDark from "assets/images/icon-yax-text-Mobile-dark.png";
import imageFileIderoTechMobile from "assets/images/iderotechMobile.png";
import iconHeadset from "assets/images/icon-headset.png";
import iconHeadsetDark from "assets/images/icon-headset-dark.png";
import { Modal } from "@material-ui/core";
import Box from "@material-ui/core/Box";
import { isMobile } from "helpers/Mobile";
import { dark } from "@material-ui/core/styles/createPalette";
import i18n from "i18n";

const HeaderTipshelf = ({
  goBackFunc,
  title,
  options,
  optionsIcons,
  buttonLabel,
  buttonHandler,
  buttonState,
  content,
  onHandleMouseDown,
  onHandleClickClean,
  darkMode,
  screenState,
  handleClickTurnScreen,
}) => {
  const [node, _] = useState(AuthService.currentNodeValue());
  const history = useHistory();


  const [open, setOpen] = React.useState(false);

  const [pressTimer, setPressTimer] = React.useState(null);
  const [pressTimer2, setPressTimer2] = React.useState(null);

  const handleInteractionStart = () => {
    setPressTimer(
      setTimeout(() => {
        history.push("/admin/devices");
      }, 3000)
    );
  };

  const handleInteractionEnd = () => {
    clearTimeout(pressTimer);
  };

  const handleInteractionIderoStart = () => {
    setPressTimer2(
      setTimeout(() => {
        onHandleMouseDown();
      }, 3000)
    );
  };

  const handleInteractionIderoEnd = () => {
    clearTimeout(pressTimer2);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleGoBack = () => {
    history.goBack();
  };


  return (
    <div className={`${styles["header-tipshelf-container"]} ${darkMode ? styles["dark"] : ""}`}>
      {!darkMode && (
        <div className={styles["left-tipshelf-container"]}>
          <i
            className={`${styles["icon-go-back-desktop"]} icon-chevron-izquierda`}
            onClick={handleGoBack}
            data-automation-id="go-back-header"
          ></i>
          <div className={styles["title-wrapper"]}>
            <div className={goBackFunc ? styles["title-go-back"] : styles["title"]}>
              {title}
            </div>
          </div>
        </div>
      )}
      <div className={!darkMode ? styles["middle-container"] : styles["left-tipshelf-container"]}>
        {!darkMode &&
          <img
            className={styles["logo-yax"]}
            src={isMobile ? imageFileYaxMobile : imageFileYax}
            alt="logo YAX"
            onMouseDown={handleInteractionStart}
            onMouseUp={handleInteractionEnd}
            onMouseLeave={handleInteractionEnd}
            onTouchStart={handleInteractionStart}
            onTouchEnd={handleInteractionEnd}
          />
        }
        {darkMode &&
          <img
            className={styles["logo-yax-dark"]}
            src={darkMode ? imageFileYaxMobileDark : (isMobile ? imageFileYaxMobile :imageFileYax)}
            alt="logo YAX"
            onMouseDown={handleInteractionStart}
            onMouseUp={handleInteractionEnd}
            onMouseLeave={handleInteractionEnd}
            onTouchStart={handleInteractionStart}
            onTouchEnd={handleInteractionEnd}
          />
        }
        {!darkMode &&
          <img
            className={styles["logo-iderotech"]}
            src={isMobile ? imageFileIderoTechMobile : imageFileIderoTech}
            alt="logo iderotech"
            onMouseDown={handleInteractionIderoStart}
            onMouseUp={handleInteractionIderoEnd}
            onMouseLeave={handleInteractionIderoEnd}
            onTouchStart={handleInteractionIderoStart}
            onTouchEnd={handleInteractionIderoEnd}
          />
        }
      </div>

      <div className={`${styles["right-tipshelf-container"]} ${darkMode ? styles["dark"] : ""}`}>
        {buttonLabel && (
          <>
            {!darkMode &&
              <div className={styles["header-button-wrapper"]}>
                <div className={styles["header-button-tip"]}>
                  <MainButton
                    legend={i18n.t("clean")}
                    state={"enabled"}
                    handleClick={onHandleClickClean}
                  ></MainButton>
                </div>
              </div>
            }
            {screenState == "ON" &&
              <div className={`${styles["header-button"]} ${darkMode ? styles["dark"] : ""}`}>
                <MainButton
                  legend={buttonLabel}
                  state={!darkMode ? buttonState : "dark"}
                  handleClick={handleOpen}
                ></MainButton>
                <Modal
                  open={open}
                  // onClose={handleClose}
                  aria-labelledby="simple-modal-title"
                  aria-describedby="simple-modal-description"
                >
                  <Box
                    className={darkMode ? styles["dark-modal"] : styles["white-modal"]}
                    style={{
                      position: "absolute",
                      top: "30%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      backgroundColor: "white",
                      padding: "1em",
                      maxWidth: "90%",
                      minWidth: "60%",
                      minHeight: "30%",
                      overflowY: "auto",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "20px"
                    }}
                  >
                    <img style={{height: "70px"}} src={darkMode ? iconHeadsetDark : iconHeadset} alt="iconHeadset" />
                    <h3 id="simple-modal-title">{i18n.t("requested.assistance")}</h3>
                    <p style={{marginBottom: "0px", marginTop: "0px"}}>{i18n.t("requested.assistance.sub")}</p>
                    <p style={{marginTop: "0px"}}> {i18n.t("requested.assistance.sub2")}</p>

                    <div className={styles["btnContainer"]}>
                      <span className={styles["btnCancel"]}>
                        <MainButton
                          legend={i18n.t("cancel.assistance")}
                          handleClick={handleClose}
                          state="enabled"
                        />
                      </span>
                    </div>
                  </Box>
                </Modal>
              </div>
            }
            {darkMode &&
              <div>
                <button className={`${styles["header-button-screen"]} ${styles[screenState]}`}
                  onClick={handleClickTurnScreen}
                ></button>
              </div>
            }
          </>
        )}
        {optionsIcons?.map(option => {
          return (
            <div
              className={styles["header-item"]}
              key={option.name}
              onClick={option.handler}
              data-automation-id="menu-option"
            >
              <Tooltip
                content={
                  <Icon
                    className={`${styles["icon"]} ${option.icon}`}
                    name={option.icon}
                    fill={"#3C7AF5"}
                    width={23}
                    height={27}
                  />
                }
                text={option.tooltip}
              ></Tooltip>
            </div>
          );
        })}
        {options.map(option => {
          return (
            <div
              className={styles["header-item"]}
              key={option.name}
              onClick={option.handler}
              data-automation-id="menu-option"
            >
              <Tooltip
                content={
                  option.icon ? (
                    <i className={`${styles["icon"]} ${option.icon}`}></i>
                  ) : (
                    <img src={option.ic}></img>
                  )
                }
                text={option.tooltip}
              ></Tooltip>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default HeaderTipshelf;
